import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {

    const lcSections = document.querySelectorAll('.logo-carousel');

    lcSections.forEach(section => {

        const lcSlider = section.querySelector('.lc-slider');
        if (!lcSlider) { return; }

        new Swiper(lcSlider, {
            spaceBetween: 32,
            slidesPerView: 1,
            loop: true,

            navigation: {
                prevEl: section.querySelector('.lc-arrow-prev'),
                nextEl: section.querySelector('.lc-arrow-next'),
            },

            pagination: {
                el: section.querySelector('.lc-pagination'),
                clickable: true,
            },

            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1025: {
                    slidesPerView: 5,
                },
            },
        });
    });

});